import React, { useState } from 'react';
import { ArrowLeft, Download, Calendar, Upload,Eye } from 'lucide-react';
// import CustomTab from './components/CustomTab';
// import CustomSearch from './components/CustomSearch';
import CustomButton from '../../../components/common/CustomButton/CustomButton';
import CustomChip from '../../../components/common/CustomChip';
import CustomDataGrid from '../../../components/common/CustomDataGrid/CustomDataGrid';
import { useNavigate } from 'react-router-dom';
// import CustomDatePicker from './components/CustomDatePicker';
import { Formik,form } from 'formik';
import CustomDatePicker from '../../../components/common/CustomDatePicker/CustomDatePicker';
import { Form } from 'formik';

const invoiceData = [
  {
    id: 1,
    invoiceNo: '9876543212',
    date: '12 Jan 2025',
    receivedAmount: '₹ 35000',
    status: 'Partially Paid',
    pendingAmount: '₹ 5000',
  },
  {
    id: 2,
    invoiceNo: '876543298',
    date: '31 Jan 2025',
    receivedAmount: '₹ 40000',
    status: 'Not-Paid',
    pendingAmount: '₹ 40000',
  },
  {
    id: 3,
    invoiceNo: '789654321',
    date: '14 Jan 2025',
    receivedAmount: '₹ 18000',
    status: 'Paid',
    pendingAmount: 'NA',
  },
  {
    id: 4,
    invoiceNo: '876543291',
    date: '11 Jan 2025',
    receivedAmount: '₹ 19000',
    status: 'Paid',
    pendingAmount: 'NA',
  },
  {
    id: 5,
    invoiceNo: '987654321',
    date: '14 Jan 2025',
    receivedAmount: '₹ 35000',
    status: 'Paid',
    pendingAmount: 'NA',
  },
  {
    id: 6,
    invoiceNo: '876543298',
    date: '11 Jan 2025',
    receivedAmount: '₹ 18000',
    status: 'Paid',
    pendingAmount: 'NA',
  },
];
const StatCard = ({ title, value }) => (
  <div className="bg-white rounded-xl shadow-md border border-gray-200 p-4">
    <h3 className="text-blue-800 text-base leading-5 font-semibold mb-2">{title}</h3>
    <p className="text-blue-900 text-2xl leading-6 font-semibold">{value}</p>
  </div>
);

const AdvsiorDetail = () => {
  const navigate = useNavigate()
  const invoiceColumns = [
    {
      field: 'invoiceNo',
      headerName: 'Invoice No.',
      width: '197.2px',
    },
    {
      field: 'date',
      headerName: 'Date',
      width: '197.2px',
    },
    {
      field: 'receivedAmount',
      headerName: 'Received Amount',
      width: '197.2px',
    },
    {
      field: 'status',
      headerName: 'Status',
      width: '197.2px',
      renderCell: (row) => (
        <CustomChip
          label={row.status}
          variant={
            row.status === 'Paid'
              ? 'success'
              : row.status === 'Partially Paid'
                ? 'warning'
                : 'error'
          }
          size="md"
        />
      ),
    },
    {
      field: 'pendingAmount',
      headerName: 'Pending Amount',
      width: '197.2px',
    },
    {
      field: 'action',
      headerName: 'Action',
      width: '150px',
      renderCell: () => (
        <CustomButton
          label="View"
          variant="text"
          startIcon={<Eye className="w-4 h-4" />}
          size="sm"
          onClick={() => {navigate("/invoicedetail") }}
        />
      ),
    },
  ];
  return (
    <div className="min-h-screen bg-gray-50 ">
      <div className=" mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center mb-8">
          <div className="flex items-center gap-4">
            <button className="p-2 hover:bg-gray-100  border rounded-md" onClick={() => { navigate("/advisor") }}>
              <ArrowLeft className="w-6 h-6 text-gray-600" />
            </button>
            <h1 className="text-2xl leading-7 font-bold text-blue-900">Advisors</h1>
          </div>
          <div className="flex items-center gap-4">
                      
                      <Formik initialValues={{ date: "" }} onSubmit={console.log}>
                        {() => (
                          <Form>
                            <CustomDatePicker name="date" label="" placeholder='Select Dates' />
                         
                          </Form>
                        )}
                      </Formik>
          
                  
                  </div>
        </div>
        {/* Advisor Info */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-8">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 bg-gray-200 rounded-full overflow-hidden">
                <img
                  src="https://ui-avatars.com/api/?name=Sidharth+Malviya&background=0D8ABC&color=fff"
                  alt="Sidharth Malviya"
                  className="w-full h-full object-cover"
                />
              </div>
              <h2 className="text-xl font-semibold text-gray-900">Sidharth Malviya</h2>
            </div>
            <CustomButton
              label="Generate Invoice"
              variant="contained"
              size="md"
              startIcon={<Download className="w-4 h-4" />}
            />
          </div>
        </div>
        {/* Stats Grid */}
        <div className="grid grid-cols-5 gap-6 mb-8">
          <StatCard title="Leads Brought" value="89" />
          <StatCard title="Converted Lead" value="24" />
          <StatCard title="Total Earning" value="₹70,000" />
          <StatCard title="Received Earning" value="₹70,000" />
          <StatCard title="Pending Payout" value="₹36,000" />
        </div>
        {/* Invoice Details */}
        <div className="">
          <div className="flex justify-between items-center py-6 border-b border-gray-200">
            <h2 className="text-xl leading-8 font-semibold text-[#0D062D] text-left">Invoice Details</h2>
            <div className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg">
              <Calendar className="w-4 h-4 text-gray-500" />
              <span className="text-sm text-gray-700">Select Dates</span>
            </div>
          </div>
          <CustomDataGrid
            columns={invoiceColumns}
            rows={invoiceData}
            keyId="id"
            perPageSize={5}
            showPagination={true}
          />
        </div>
      </div>
    </div>
  )
}

export default AdvsiorDetail

